import { Component } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { Video } from './model/video.model';
import { VideoService } from './service/video.service';
import { VideoResponse } from './model/video-response.model';
import { NgFor } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


@Component({
  selector: 'app-video',
  standalone: true,
  imports: [TranslateModule, NgFor],
  templateUrl: './video.component.html',
  styleUrl: './video.component.css'
})
export class VideoComponent {

  videoData: Video[] = [];

  baseApiUrl = environment.baseApiUrl;

  pagination = {
    page: 1,
    limit: 100
  }

  constructor(private videoService: VideoService, private translate: TranslateService, private sanitizer: DomSanitizer) {}

  isKhmer(): boolean {
    return this.translate.currentLang === 'kh';
  }

  isEnglish(): boolean {
    return this.translate.currentLang === 'en';
  }

  ngOnInit(): void { 
    this.loadVideos(this.pagination.page, this.pagination.limit);
  }

  loadVideos(page: number, limit: number) {
    this.videoService.getVideos(page, limit).subscribe(
      (Response: VideoResponse) => {
        this.videoData = Response.data.videos.map(video => ({
          ...video
        }));
      },
      (error) => {
        console.log('Error fetching videos: ', error);
      }
    )
  }

  getSafeEmbedUrl(youtubeUrl: string): SafeResourceUrl {
    const videoId = this.extractVideoId(youtubeUrl);
    const embedUrl = `https://www.youtube.com/embed/${videoId}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }

  private extractVideoId(url: string): string | null {
    const regex = /[?&]v=([^&#]*)/;
    const match = url.match(regex);
    return match ? match[1] : '';
  }

}
